export const ALLOWED_CREATIVE_FORMATS = ['image/jpeg', 'image/png', 'image/jpg'];
export const ALLOWED_CREATIVE_FORMAT_EXTENSIONS = '.png,.jpg,.jpeg';
export const CREATIVE_FORMAT_IMAGE_PNG = 'image/png';
export const CREATIVE_FORMAT_IMAGE_PNG_EXTENSION = '.png';

export function isCreativeFormatValid(file: File[], allowedFormats: string[]): boolean {
  return allowedFormats.includes(file[0].type);
}
